<div>
    <dx-lookup #itemLookup
            [dataSource]="datasource"
            [disabled]="isReadOnly"
            [displayExpr]="displayExpr"
            [valueExpr]="valueExpr"
            [placeholder]="placeholder"
            [(value)]="value"
            [showClearButton]="true"
            (onValueChanged)="itemSelectedInternal($event)"
            [isValid]="!isRequired"
            [itemTemplate]="itemTemplate ? 'item' : null"
            [fieldTemplate]="fieldTemplate && value ? 'field' : null"
            >

            <dxo-drop-down-options title="Select item"></dxo-drop-down-options>

            <div *dxTemplate="let item of 'item'">
                <ng-template
                  [ngTemplateOutlet]="itemTemplate"
                  [ngTemplateOutletContext]="{ item: item }">
                </ng-template>
            </div>
    
            <div *dxTemplate="let item of 'field'">
                <ng-template
                  [ngTemplateOutlet]="fieldTemplate"
                  [ngTemplateOutletContext]="{ item: item }">
                </ng-template>
            </div>
    </dx-lookup>
</div>
